import React, { Component } from "react"
import PropTypes from "prop-types"
import api from "../../service/api"
import "./index.scss"
// import HeaderBar from "../HeaderBar/index"
import ArticleHeaderImage from "../aelComponent/ArticleHeaderImage/index"
import ArticleHeaderVideo from "../aelComponent/ArticleHeaderVideo/index"
import ArticleHeaderContent from "../aelComponent/ArticleHeaderContent/index"
// import utils from 'bxl-utils';

class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isUp: false,
      startPlay: false
    }
    this.windowOnScroll = this.windowOnScroll.bind(this)
    this.share = this.share.bind(this)
    this.playVideo = this.playVideo.bind(this)
  }

  componentDidMount() {
    window.addEventListener("scroll", this.windowOnScroll)
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.windowOnScroll)
  }
  windowOnScroll() {
    let _this = this
    const { header } = this.props
    if (header && !header.video) {
      //获取滚动条滚动的距离
      let sTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop

      if (sTop + 60 >= this.section0.offsetHeight) {
        if (!_this.state.isUp) {
          _this.setState({
            isUp: true
          })
        }
      } else {
        if (_this.state.isUp) {
          _this.setState({
            isUp: false
          })
        }
      }
    }

  }

  handleImgOrVideo = () => {
    const { header } = this.props
    if (header) {
      return header.video ? (
        <ArticleHeaderVideo startPlay={this.state.startPlay} src={api.getResource(header.video)} />
      ) : header.image ? (
        <ArticleHeaderImage src={api.getResource(header.image)} />
      ) : null
    } else {
      return null
    }
  }

  playVideo(){
    this.setState({
      startPlay: true
    })
  }

  share() {
    this.props.showShare();
  }

  /**
   * 组件加载默认渲染白色bar， 头部是图片不是视频时  滑动超过img的一半 切换黑色组件，隐藏图片
   * @returns {*}
   */
  render() {
    const { header, meta } = this.props
    return (
      <div className={ !this.handleImgOrVideo() ? "articleHeader articleHeaderNoneImg" : "articleHeader"  }>
        <div
          className="articleHeaderImgOrVideo"
          ref={section => {
            this.section0 = section
          }}>
          {this.handleImgOrVideo()}
        </div>

        <ArticleHeaderContent {...header} meta={meta} />
      </div>
    )
  }
}

Index.propTypes = {
  data: PropTypes.object,
  style: PropTypes.object
}

export default Index
